import { FontConfig } from "../types"

export const HEADING_3_CONFIG: FontConfig = {
  title: "Headings/h3",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 20, tw: "text-[20px]" },
    lineHeight: { px: 30, tw: "leading-[30px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 32, tw: "text-[32px]" },
    lineHeight: { px: 48, tw: "leading-[48px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 46, tw: "text-[46px]" },
    lineHeight: { px: 69, tw: "leading-[69px]" },
  },
}
